import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import Dropzone from "./drop-zone";
import Button from "cxa-components/button";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const FileUploader = ({ className, disabled, error, onChange, buttonLabel, tipLabel, ...rest }) => {
  const prefixCls = "file-uploader";

  const componentCls = classnames(
    prefixCls,
    {
      [`${prefixCls}--disabled`]: disabled,
      [`${prefixCls}--error`]: error,
    },
    className
  );

  const componentActiveCls = classnames({
    [`${prefixCls}--active`]: !disabled,
  });

  const buttonCls = classnames(`${prefixCls}__button button--secondary`);

  return (
    <div>
      <Dropzone
        className={componentCls}
        activeClassName={componentActiveCls}
        onDrop={acceptedFiles => onChange(acceptedFiles)}
        disableClick={disabled}
        {...rest}
      >
        <Button primary type="button" disabled={disabled} className={buttonCls}>
          {buttonLabel || <FormattedMessage {...messages.browseFilesDescription} />}
        </Button>
        {tipLabel || <FormattedMessage {...messages.dropThemHereDescription} />}
      </Dropzone>
    </div>
  );
};

FileUploader.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  buttonLabel: PropTypes.node,
  tipLabel: PropTypes.node,
};

export default FileUploader;



// WEBPACK FOOTER //
// ./components/common/file-uploader/file-uploader.js